/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FileTypePictureIcon24Solid = forwardRef('FileTypePictureIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.201 2.879A3 3 0 0 0 13.08 2H8a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V8.92a3 3 0 0 0-.879-2.121l-3.92-3.92ZM11 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.837 5.266a.875.875 0 0 1 1.237 0l1.812 1.812a1 1 0 0 0 1.415-1.414l-1.813-1.813a2.875 2.875 0 0 0-4.066 0l-4.38 4.38a1 1 0 1 0 1.415 1.414l4.38-4.38Z" })));
});
